import script from "./ViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllGroupTalks.vue?vue&type=style&index=0&id=924df594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-924df594"]])

export default __exports__